import React from 'react'
import moment from 'moment'

import {
  toWeekStartDate,
  toWeekEndDate,
  toMonthCalendarStartDate,
  toMonthCalendarEndDate,
  toMonthStartDate,
  toMonthEndDate
} from '../../../helpers/moment.js'

import WeekMonthControl from './WeekMonthControl'
import WeekView from './WeekView'
import MonthView from './MonthView'

const Calendar = ({
  client,
  activeSite,
  activeView,
  toggleViewHandler,
  activeDate,
  setActiveDate,
  activeWeek,
  setActiveWeek,
  activeMonth,
  setActiveMonth,
  shifts
}) => {
  const startDay = client ? client.start_day : 0

  const todayHandler = () => {
    setActiveDate(moment())

    setActiveWeek({
      startDate: toWeekStartDate(moment(), client.start_day),
      endDate: toWeekEndDate(moment(), client.start_day)
    })

    setActiveMonth({
      startDate: toMonthStartDate(moment(), client.start_day),
      endDate: toMonthEndDate(moment(), client.start_day),
      calendarStartDate: toMonthCalendarStartDate(moment(), client.start_day),
      calendarEndDate: toMonthCalendarEndDate(moment(), client.start_day)
    })
  }

  const activeDateHandler = date => setActiveDate(date)

  const prevWeekHandler = () => {
    setActiveWeek({
      startDate: activeWeek.startDate.clone().subtract('7', 'days'),
      endDate: activeWeek.endDate.clone().subtract('7', 'days')
    })

    setActiveDate(activeWeek.startDate.clone().subtract('7', 'days'))
  }

  const nextWeekHandler = () => {
    setActiveWeek({
      startDate: activeWeek.startDate.clone().add('7', 'days'),
      endDate: activeWeek.endDate.clone().add('7', 'days')
    })

    setActiveDate(activeWeek.startDate.clone().add('7', 'days'))
  }

  const prevMonthHandler = () => {
    let updatedMonth = activeMonth.startDate.clone().subtract(1, 'month')

    setActiveMonth({
      startDate: toMonthStartDate(
        moment(moment(updatedMonth).clone()).clone(),
        startDay
      ),
      endDate: toMonthEndDate(moment(updatedMonth).clone(), startDay),
      calendarStartDate: toMonthCalendarStartDate(
        moment(updatedMonth).clone(),
        startDay
      ),
      calendarEndDate: toMonthCalendarEndDate(
        moment(updatedMonth).clone(),
        startDay
      )
    })

    setActiveDate(toMonthEndDate(moment(updatedMonth).clone(), startDay))
  }

  const nextMonthHandler = () => {
    let updatedMonth = activeMonth.startDate.clone().add(1, 'month')

    setActiveMonth({
      startDate: toMonthStartDate(moment(updatedMonth).clone(), startDay),
      endDate: toMonthEndDate(moment(updatedMonth).clone(), startDay),
      calendarStartDate: toMonthCalendarStartDate(
        moment(updatedMonth).clone(),
        startDay
      ),
      calendarEndDate: toMonthCalendarEndDate(
        moment(updatedMonth).clone(),
        startDay
      )
    })

    setActiveDate(toMonthStartDate(moment(updatedMonth).clone(), startDay))
  }
  let view =
    activeView === 'week' ? (
      <div>
        <WeekView
          activeDate={activeDate}
          activeWeek={activeWeek}
          startDay={startDay}
          backToToday={todayHandler}
          changeActiveDate={activeDateHandler}
          changeToNextWeek={nextWeekHandler}
          changeToPrevWeek={prevWeekHandler}
        />
      </div>
    ) : activeView === 'month' ? (
      <MonthView
        shifts={shifts}
        activeDate={activeDate}
        activeMonth={activeMonth}
        startDay={startDay}
        backToToday={todayHandler}
        changeActiveDate={activeDateHandler}
        changeToNextMonth={nextMonthHandler}
        changeToPrevMonth={prevMonthHandler}
      />
    ) : null
  return (
    <div className="container bg-white pb-1">
      {/* <WeekMonthControl
        activeView={activeView}
        toggleViewHandler={toggleViewHandler}
      /> */}
      {view}
    </div>
  )
}

export default Calendar
